// アコーディオン機能の実装
document.addEventListener('DOMContentLoaded', function () {
  const toggles = document.querySelectorAll('.accordion-toggle');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', function () {
      const content = document.querySelector(`#${toggle.getAttribute('aria-controls')}`);
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        content.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        content.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }

      const icon = toggle.querySelector('i');
      if (isExpanded) {
        icon.classList.remove('fa-chevron-up');
        icon.classList.add('fa-chevron-down');
      } else {
        icon.classList.remove('fa-chevron-down');
        icon.classList.add('fa-chevron-up');
      }
    });
  });
});

// 商品画像サムネイルにマウスホバーしたときにメイン画像を切り替える
document.addEventListener('DOMContentLoaded', function () {
  var thumbnails = document.querySelectorAll('.product-single__thumbnail-image');

  var mainImage = document.querySelector('.product-single__media-group img');

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('mouseenter', function () {
      var largeImageUrl = thumbnail.parentElement.href;
      mainImage.setAttribute('src', largeImageUrl);
    });
  });

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('mouseleave', function () {
      var defaultImageUrl = document.querySelector('.product-single__media-group img').getAttribute('src'); // デフォルトの画像URLを取得
      mainImage.setAttribute('src', defaultImageUrl);
    });
  });
});
